<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Customer Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "TARRIFSETUP_TARIFF_CUSTOMER_TYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let type of customerTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-customer-' + type">
            <input type="checkbox" [id]="'checkbox-customer-' + type"
              [checked]="isIn(draftCustomerTypes, type)"
              (change)="draftCustomerTypes = toggle(draftCustomerTypes, type)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-customer-' + type">{{ type | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Tariff Status -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "TARRIFSETUP_TARIFF_STATUS" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let status of tariffStatuses">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-tariff-' + status">
            <input type="checkbox" [id]="'checkbox-tariff-' + status"
              [checked]="isIn(draftTariffStatuses, status)"
              (change)="draftTariffStatuses = toggle(draftTariffStatuses, status)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-tariff-' + status">{{ status | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Name Search -->
  <div class="row g-0 m-0">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "TARIFF_NAME_SEARCH" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3 tariff-name-search">
      <input type="text" class="form-control p-2" [(ngModel)]="draftNameSearch"
        placeholder="{{ 'SEARCH_TARIFF_NAME' | translate }}" />
    </div>
  </div>

</app-filter-panel>
